import { useToastStore } from '../lib/toast';

const TONE = {
  success: 'border-[var(--c-ok)] bg-[var(--c-ok-soft)] text-[var(--c-ok)]',
  error: 'border-[var(--c-danger)] bg-[var(--c-danger-soft)] text-[var(--c-danger)]',
  info: 'border-[var(--c-border-strong)] bg-[var(--c-surface)] text-[var(--c-ink)]',
} as const;

/** Uygulamada TEK örnek. main.tsx içinde router'ın dışında durur. */
export function ToastHost() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  if (toasts.length === 0) return null;

  return (
    <div
      className="pointer-events-none fixed bottom-4 right-4 z-[100] flex w-full max-w-sm flex-col gap-2"
      aria-live="polite"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`pointer-events-auto flex items-start gap-3 rounded-[var(--r-md)] border px-3 py-2 shadow-[var(--sh-md)] ${TONE[t.kind]}`}
        >
          <div className="min-w-0 flex-1">
            <p className="text-sm">{t.message}</p>
            {t.detail && <p className="mt-0.5 font-mono text-[11px] opacity-70">{t.detail}</p>}
          </div>
          <button
            type="button"
            onClick={() => dismiss(t.id)}
            aria-label="Bildirimi kapat"
            className="shrink-0 opacity-60 hover:opacity-100"
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
